import Text from "components/shared/stays/Text";
import SurfSeasonDot from "components/shared/stays/SurfSeasonDot";
import styles from "components/shared/stays/SurfSeasonLegend.module.scss";

export default function SurfSeasonLegend() {
  return (
    <div className={styles.component}>
      <div className={styles.keys}>
        <div className={styles.key}>
          <SurfSeasonDot season="h" />
          <Text size={2}>
            Peak
            <span className={styles.season}>{" swell"}</span>
          </Text>
        </div>
        <div className={styles.key}>
          <SurfSeasonDot season="m" />
          <Text size={2}>
            Variable
            <span className={styles.season}>{" swell"}</span>
          </Text>
        </div>
      </div>
    </div>
  );
}
